import perfil from '@/helpers/perfil';
import usuarioHelper from '@/helpers/usuario-logado.js';

export default {
  verificaAcesso: function (instance, routeName) {
    if (!routeName) return false;
    const listaPermissoes = usuarioHelper.USUARIO_LOGADO().perfil.permissoes;
    const rota = instance.$root.$options.router.options.routes.filter(route => route.name == routeName)

    return listaPermissoes.filter(permissao => permissao.id == rota[0].meta.permissao).length;
  },
  verificaPermissao: function (permissaoSolicitada) {
    if (!permissaoSolicitada) return false;
    const listaPermissoes = usuarioHelper.USUARIO_LOGADO().perfil.permissoes;
    return listaPermissoes.filter(permissao => permissao.id == permissaoSolicitada).length;
  },
  getPermissao: function (permissaoSolicitada) {
    if (!permissaoSolicitada) {
      return false;
    }
    const listaPermissoes = usuarioHelper.USUARIO_LOGADO().perfil.permissoes;
    return listaPermissoes.find(permissao => permissao.id == permissaoSolicitada) ? true : false;
  },
  getMapaPermissoes: function() {
    const permissoes = Object.keys(process.env.PERMISSOES).map(key => {
      return process.env.PERMISSOES[key];
    });

    let map = new Map();
    permissoes.forEach(permissao => {
      map.set(permissao.titulo, this.getPermissao(permissao.id));
    });

    return map;
  },
  //Os dois objetos abaixo representam o sistema antigo que deve ser desativado
  Questionario: {
    salvarDadosUsuario: !usuarioHelper.USUARIO_LOGADO() ||
                        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL ||
                        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ANALISTA ||
                        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ADMINISTRADOR ||
                        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.PLATAFORMA
  },
  SolicitacaoConsulta: {
    ACESSO_AUDITORIA: 1,
    COTAR_SEGURO: 2,
    ANALISA_SOLICITACAO : 4,
    VISUALIZA_SOLICITACAO_TIPO_CLIENTE: 9
  },
  usuarioTemPermissao: function(usuario, permissaoSolicitada) {
    if (!usuario || !permissaoSolicitada) {
      return false;
    }
    const listaPermissoes = usuario.perfil.permissoes;
    return listaPermissoes.find(permissao => permissao.id == permissaoSolicitada) ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/permissoes.js